import { Outlet } from "react-router-dom";

import { SpinnerFullPage } from "src/core/components/custom-ui/spinner-full-page";
import { Header } from "src/core/components/header/Header";
import { useTenant } from "src/core/contexts/TenantContext/TenantProvider";
import { TENANT_STATUS } from "src/core/types/tenant";

export const Layout: React.FC<{ className?: string }> = ({ className = "layout-container" }) => {
  const { status } = useTenant();
  const isSwitching = status === TENANT_STATUS.SWITCHING;

  return (
    <div className={className}>
      <Header />
      <div className="outlet-container">
        <div className="relative z-10 h-full flex flex-row">
          <Outlet />

          {isSwitching ? (
            <div
              className="absolute inset-0 z-50 flex items-center justify-center bg-background/60"
              aria-busy="true"
              aria-live="polite"
              data-testid="tenant-switch-overlay"
            >
              <SpinnerFullPage />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
